import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewCollection from 'Views/view-collection';
import ViewCollectionNav from 'Views/view-collectionNav';
import OneQuickShopv2 from 'Modules/module-oneQuickShopv2';

"use strict";
    
var collection,
    rebuilt = false;

// For lazy loading
ORW.pagerStack = [];
ORW.isLoading = false;
ORW.isFinished = false;
    
ORW.rebuildListing = function(){
    if (rebuilt) {
        console.log('rebuilt listing');
    } else {
        console.log('init listing');
    }

    if (collection) { 
        collection.destroy();
    }
    
    collection = $('.product-collection').length ? new ViewCollection({el: $('.product-collection') }) : false;

    if (!rebuilt) rebuilt = true;
};

// Global requires
whenDomReady(function(){
    $('.collection-nav').length && new ViewCollectionNav({el: $('.collection-nav') });

    if ( $('.product-collection').length && $('.product-collection').data('quickshop') ) {
        OneQuickShopv2.init({});
    }

    ORW.rebuildListing();
});